import React from 'react';
import { RouteObject } from 'react-router-dom';
import { appRoutes } from '../path';
import { EmbedLogin, Login, SsoLogin } from './Auth/LoginPages';
import ErrorPage from './ErrorPage';

/**
 * Routes that don't rely on Bootstrap and Auth
 */
const publicRoutes: RouteObject[] = [
  {
    path: appRoutes.ssoLogin,
    element: <SsoLogin />,
  },
  {
    path: appRoutes.login,
    element: <Login />,
  },
  {
    path: appRoutes.errorPage,
    element: <ErrorPage />,
  },
  {
    path: appRoutes.embedLogin,
    element: <EmbedLogin />,
  },
];

export default publicRoutes;
